import store from "@state/store";

// auth related routes
const authRoutes = [
  {
    path: "/login",
    name: "login",
    component: () => lazyLoadView(import("@views/pages/account/login")),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ path: "/" });
        } else {
          // Continue to the login page
          next();
        }
      }
    }
  },
  {
    path: "/myaccount",
    component: () => lazyLoadView(import("@views/pages/account/account")),
    meta: { authRequired: true },
    props: route => ({ user: store.state.auth.currentUser || {} })
  },
  {
    path: "/register",
    name: "register",
    component: () => lazyLoadView(import("@views/pages/account/register")),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ path: "/" });
        } else {
          // Continue to the login page
          next();
        }
      }
    }
  },
  {
    path: "/confirm-account",
    name: "confirm-account",
    component: () => lazyLoadView(import("@views/pages/account/confirm")),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ path: "/" });
        } else {
          // Continue to the login page
          next();
        }
      }
    }
  },
  {
    path: "/forget-password",
    name: "forget-password",
    component: () =>
      lazyLoadView(import("@views/pages/account/forgetPassword")),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ path: "/" });
        } else {
          // Continue to the login page
          next();
        }
      }
    }
  },
  {
    path: "/set-password",
    name: "set-password",
    component: () =>
      lazyLoadView(import("@views/pages/account/setPassword")),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ path: "/" });
        } else {
          // Continue to the login page
          next();
        }
      }
    }
  },
  {
    path: "/logout",
    name: "logout",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch("auth/logOut");
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          route => route.meta.authRequired
        );
        // Navigate back to previous page, or home as a fallback
        next(
          authRequiredOnPreviousRoute
          ? { path: "/" }
          : { ...routeFrom }
        );
      }
    }
  }
];

// error pages
const errorPagesRoutes = [
  {
    path: "/404",
    name: "404",
    component: require("@views/pages/secondary/error-404").default,
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true
  },
  {
    path: "/500",
    name: "500",
    component: require("@views/pages/secondary/error-500").default,
    props: true
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: "*",
    redirect: "404"
  }
];

// dashboard
// const dashboardRoutes = [
//   {
//     path: '/',
//     name: 'Dashboard',
//     header: 'Navigation',
//     icon: 'home',
//     // badge: {
//     //   text: '1',
//     //   varient: 'success',
//     // },
//     component: () => lazyLoadView(import('@views/pages/dashboard/dashboard')),
//     meta: { authRequired: true },
//     props: (route) => ({ user: document.cookie || {} }),
//   },
// ]

const homeRoutes = [
  {
    path: "/",
    icon: "home",
    // badge: {
    //   text: '1',
    //   varient: 'success',
    // },
    component: () => lazyLoadView(import("@views/pages/index")),
    meta: { authRequired: true },
    props: route => ({ user: document.cookie || {} })
  }
];

const dashboardRoutes = [
  {
    path: "/dashboard",
    menuTitle: "Dashboard",
    icon: "grid",
    meta: { authRequired: true },
    // create a container component
    component: {
      render(c) {
        return c("router-view");
      }
    },
    children: [
      {
        path: "",
        name: "Overview",
        component: () => lazyLoadView(import("@views/pages/dashboard/index")),
        meta: { authRequired: true },
        props: route => ({ user: store.state.auth.currentUser || {} })
      },
      // {
      //   path: "test",
      //   name: "Dashboard Test",
      //   component: () => lazyLoadView(import("@views/pages/dashboard/test")),
      //   meta: { authRequired: true },
      //   props: route => ({ user: store.state.auth.currentUser || {} })
      // },
      {
        path: "saler",
        name: "Saler",
        component: () => lazyLoadView(import("@views/pages/dashboard/saler")),
        meta: { authRequired: true },
        props: route => ({ user: store.state.auth.currentUser || {} })
      },
      {
        path: "account",
        name: "Account Dashboard",
        component: () => lazyLoadView(import("@views/pages/dashboard/account")),
        meta: { authRequired: true },
        props: route => ({ user: store.state.auth.currentUser || {} })
      },
      {
        path: "delivery",
        name: "Delivery",
        component: () =>
          lazyLoadView(import("@views/pages/dashboard/delivery")),
        meta: { authRequired: true },
        props: route => ({ user: store.state.auth.currentUser || {} })
      }
    ]
  }
];

// product routes
const productRoutes = [
  {
    path: "/product",
    menuTitle: "Product",
    headers: "Product",
    icon: "package",
    component: {
      render(c) {
        return c("router-view");
      }
    },
    meta: { authRequired: true },
    props: route => ({ user: store.state.auth.currentUser || {} }),
    children: [
      // {
      //   name: 'Brands',
      //   path: 'brand',
      //   meta: { authRequired: true },
      //   component: () =>
      //     lazyLoadView(import('@views/pages/product/brand/Brand')),
      // },
      {
        path: "/product/brand/manage",
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import("@views/pages/product/brand/manage/index"))
      },
      {
        path: "/product/brand/manage/:id",
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import("@views/pages/product/brand/manage/index"))
      },

      {
        name: "Categories",
        path: "category",
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import("@views/pages/product/category/Category"))
      },
      {
        name: "Products",
        path: "",
        meta: { authRequired: true },
        component: () => lazyLoadView(import("@views/pages/product/index"))
      },
      {
        path: "/product/manage",
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import("@views/pages/product/manage/index"))
      },
      {
        path: "/product/manage/:id",
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import("@views/pages/product/manage/index"))
      }
    ]
  }
];

const userRoutes = [
  {
    path: "/adminaccount",
    name: "Manage Admin",
    icon: "user",
    component: () => lazyLoadView(import("@views/pages/admin/index")),
    meta: { authRequired: true },
    props: route => ({ user: store.state.auth.currentUser || {} })
  },
  {
    path: "/adminaccount/manage",
    component: () => lazyLoadView(import("@views/pages/admin/manage/index")),
    meta: { authRequired: true },
    props: route => ({ user: store.state.auth.currentUser || {} })
  }
];

const manageMemberRoutes = [
  {
    path: "/member",
    menuTitle: "Manage Member",
    headers: "Manage Member",
    icon: "user",
    component: {
      render(c) {
        return c("router-view");
      }
    },
    meta: { authRequired: true },
    props: route => ({ user: store.state.auth.currentUser || {} }),
    children: [
      {
        name: "Manage Member",
        path: "",
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import("@views/pages/user/manageMember/index"))
      },
      {
        path: "manage/",
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import("@views/pages/user/manageMember/manage/index"))
      },
      {
        path: "manage/:id",
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import("@views/pages/user/manageMember/manage/index"))
      },
      {
        path: "manage/:id/:mode",
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import("@views/pages/user/manageMember/manage/index"))
      },      
      {
        name: "Approve New Member",
        path: "approve",
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import("@views/pages/user/approveMember/index"))
      },
      {
        path: "approve/:id",
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import("@views/pages/user/approveMember/manage/index"))
      },
      {
        name: "Member Approval History",
        path: "history",
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import("@views/pages/user/approveMemberHistory/index"))
      },
      {
        name: "Approve Spending Limit",
        path: "spending",
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import("@views/pages/user/approveSpending/index"))
      },
      {
        name: "Spending Limit Approval History",
        path: "spending/history",
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import("@views/pages/user/spendingLimitHistory/index"))
      },
      {
        name: "Invoice Approval",
        path: "invoiceapproval",
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import("@views/pages/user/invoiceApproval/index"))
      },
      {
        path: "invoiceapproval/approve/:id",
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import("@views/pages/user/invoiceApproval/manage/index"))
      },
      {
        name: "Invoice Approval History",
        path: "invoiceapproval/history",
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import("@views/pages/user/invoiceApproveHistory/index"))
      },
    ]
  }
];

const manageMemberAdminACCRoutes = [
  {
    path: "/member",
    menuTitle: "Manage Member",
    headers: "Manage Member",
    icon: "user",
    component: {
      render(c) {
        return c("router-view");
      }
    },
    meta: { authRequired: true },
    props: route => ({ user: store.state.auth.currentUser || {} }),
    children: [
      {
        name: "Approve Spending Limit",
        path: "spending",
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import("@views/pages/user/approveSpending/index"))
      },
      {
        name: "Spending Limit Approval History",
        path: "spending/history",
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import("@views/pages/user/spendingLimitHistory/index"))
      },
      {
        name: "Invoice Approval",
        path: "invoiceapproval",
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import("@views/pages/user/invoiceApproval/index"))
      },
      {
        path: "invoiceapproval/approve/:id",
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import("@views/pages/user/invoiceApproval/manage/index"))
      },
      {
        name: "Invoice Approval History",
        path: "invoiceapproval/history",
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import("@views/pages/user/invoiceApproveHistory/index"))
      },
    ]
  }
];

const memberApproveRoutes = [
  {
    path: "/memberapprove/history",
    name: "Member Approval History",
    icon: "user",
    meta: { authRequired: true },
    component: () =>
      lazyLoadView(import("@views/pages/user/approveMemberHistory/index"))
  },
];

const manageDeliveryRoutes = [
  {
    path: "/delivery",
    name: "Manage Delivery",
    headers: "Manage Delivery",
    icon: "truck",
    component: {
      render(c) {
        return c("router-view");
      }
    },
    meta: { authRequired: true },
    props: route => ({ user: store.state.auth.currentUser || {} }),
    children: [
      {
        name: "Waiting Delivery Note",
        path: "waitingnote",
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import("@views/pages/delivery/waitingNote/index"))
      },
      {
        path: "waitingnote/manage",
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import("@views/pages/delivery/waitingNote/manage/index"))
      },
      {
        path: "waitingnote/manage/:id",
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import("@views/pages/delivery/waitingNote/manage/index"))
      },
      {
        name: "Delivery Order List",
        path: "orderlist",
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import("@views/pages/delivery/orderList/index"))
      },
      {
        path: "orderlist/manage/:id",
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import("@views/pages/delivery/orderList/manage/index"))
      },
    ]
  }
];

const contentRoutes = [
  {
    path: "/content",
    name: "content and news",
    icon: "",
    component: () => lazyLoadView(import("@views/pages/content/index")),
    meta: { authRequired: true },
    props: route => ({ user: store.state.auth.currentUser || {} })
  },
  {
    path: "/content/create",
    meta: { authRequired: true },
    component: () => lazyLoadView(import("@views/pages/content/create"))
  },
  {
    path: "/content/edit/:id",
    meta: { authRequired: true },
    component: () => lazyLoadView(import("@views/pages/content/edit"))
  },
];

const waitingDeliveryNoteRoutes = [
  {
    path: "/waitingnote",
    name: "Waiting Delivery Note",
    headers: "Waiting Delivery Note",
    icon: "grid",
    component: () => lazyLoadView(import("@views/pages/delivery/waitingNote/index")),
    meta: { authRequired: true },
    props: route => ({ user: store.state.auth.currentUser || {} })
  },
  {
    path: "/waitingnote/manage",
    meta: { authRequired: true },
    component: () =>
      lazyLoadView(import("@views/pages/delivery/waitingNote/manage/index"))
  },
  {
    path: "/waitingnote/manage/:id",
    meta: { authRequired: true },
    component: () =>
      lazyLoadView(import("@views/pages/delivery/waitingNote/manage/index"))
  }, 
];

const deliveryOrderListRoutes = [
  {
    path: "/orderlist",
    name: "Delivery Order List",
    headers: "Delivery Order List",
    icon: "grid",
    component: () => lazyLoadView(import("@views/pages/delivery/orderList/index")),
    meta: { authRequired: true },
    props: route => ({ user: store.state.auth.currentUser || {} })
  },
  {
    path: "/orderlist/manage/:id",
    meta: { authRequired: true },
    component: () =>
      lazyLoadView(import("@views/pages/delivery/orderList/manage/index"))
  }, 
];

const deliveryListRoutes = [
  {
    path: "/delivery",
    name: "Delivery List",
    headers: "Delivery List",
    icon: "grid",
    component: () => lazyLoadView(import("@views/pages/delivery/deliveryList/index")),
    meta: { authRequired: true },
    props: route => ({ user: store.state.auth.currentUser || {} })
  },
];

const reportRoutes = [
  {
    path: "/report",
    name: "Report",
    headers: "Report",
    icon: "file-text",
    component: {
      render(c) {
        return c("router-view");
      }
    },
    meta: { authRequired: true },
    props: route => ({ user: store.state.auth.currentUser || {} }),
    children: [
      {
        name: "System Overview Report",
        path: "systemoverview",
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import("@views/pages/report/systemoverview"))
      },
      {
        name: "Order report",
        path: "orderreport",
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import("@views/pages/report/orderreport"))
      },
      {
        name: "Amount report",
        path: "amountreport",
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import("@views/pages/report/amountreport"))
      },
      // {
      //   name: "Member report",
      //   path: "memberreport",
      //   meta: { authRequired: true },
      //   component: () =>
      //     lazyLoadView(import("@views/pages/report/memberreport"))
      // },
      {
        name: "Backorder report",
        path: "backorderreport",
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import("@views/pages/report/backorderreport"))
      },
      {
        name: "Invoice report",
        path: "invoicereport",
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import("@views/pages/report/invoicereport"))
      },
      {
        name: "Delivery report",
        path: "deliveryreport",
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import("@views/pages/report/deliveryreport"))
      },
      {
        name: "Log detail report",
        path: "logdetail",
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import("@views/pages/report/logDetail"))
      },
     
    ]
  }
];

const cartRoutes = [
  {
    path: "/cart",
    name: "Cart",
    icon: "shopping-cart",
    component: () => lazyLoadView(import("@views/pages/cart/Cart")),
    meta: { authRequired: true },
    props: route => ({ user: store.state.auth.currentUser || {} })
  },
  {
    path: "/cart/product",
    meta: { authRequired: true },
    component: () => lazyLoadView(import("@views/pages/cart/product"))
  },
  {
    path: "/cart/product/:id",
    meta: { authRequired: true },
    component: () =>
      lazyLoadView(import("@views/pages/cart/detail"))
  }  
];

const orderRoutes = [
  {
    path: "/order",
    name: "Order List",
    icon: "grid",
    meta: { authRequired: true },
    // create a container component
    component: {
      render(c) {
        return c("router-view");
      }
    },
    children: [
      // {
      //   path: 'pendingpayment',
      //   name: 'Pending payment',
      //   component: () => lazyLoadView(import('@/src/router/views/pages/order/pendingpayment')),
      //   meta: { authRequired: true },
      //   props: (route) => ({ user: store.state.auth.currentUser || {} }),
      // },      
      // {
      //   path: 'status',
      //   name: 'Order status',
      //   component: () =>
      //     lazyLoadView(import('@/src/router/views/pages/order/status')),
      //   meta: { authRequired: true },
      //   props: (route) => ({ user: store.state.auth.currentUser || {} }),
      // },
      // {
      //   path: 'history',
      //   name: 'Order history',
      //   component: () => lazyLoadView(import('@/src/router/views/pages/order/history/history')),
      //   meta: { authRequired: true },
      //   props: (route) => ({ user: store.state.auth.currentUser || {} }),
      // },
      {
        path: 'quotations',
        name: 'Quotations',
        component: () => lazyLoadView(import('@/src/router/views/pages/order/quotation/index')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'saleorders',
        name: 'Sale Orders',
        component: () => lazyLoadView(import('@/src/router/views/pages/order/saleOrder/index')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      }, 
      {
        path: 'backorder',
        name: 'Backorder',
        component: () => lazyLoadView(import('@/src/router/views/pages/order/backOrder/index')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      }, 
      {
        path: 'invoices',
        name: 'Invoices',
        component: () => lazyLoadView(import('@/src/router/views/pages/order/invoice/index')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },                 
    ],
  },
  {
    path: '/order/quotations/:orderId',
    component: () =>
      lazyLoadView(import('@/src/router/views/pages/order/quotation/detail')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },    
  {
    path: '/order/saleorders/:orderId',
    component: () =>
      lazyLoadView(import('@/src/router/views/pages/order/saleOrder/detail')),
    meta: { authRequired: true },
    props: route => ({ user: store.state.auth.currentUser || {} })
  },
  {
    path: '/order/backorder/:orderId',
    component: () =>
      lazyLoadView(import('@/src/router/views/pages/order/backOrder/detail')),
    meta: { authRequired: true },
    props: route => ({ user: store.state.auth.currentUser || {} })
  },
  {
    path: '/order/invoices/:orderId',
    component: () =>
      lazyLoadView(import('@/src/router/views/pages/order/invoice/detail')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },    
  // {
  //   path: '/order/history/:orderId',
  //   component: () =>
  //     lazyLoadView(import('@/src/router/views/pages/order/history/detail')),
  //   meta: { authRequired: true },
  //   props: (route) => ({ user: store.state.auth.currentUser || {} }),
  // },
  // {
  //   path: '/order/step1',
  //   component: () =>
  //     lazyLoadView(import('@/src/router/views/pages/order/step1')),
  //   meta: { authRequired: true },
  //   props: (route) => ({ user: store.state.auth.currentUser || {} }),
  // },
  // {
  //   path: '/order/step2',
  //   component: () =>
  //     lazyLoadView(import('@/src/router/views/pages/order/step3')),
  //   meta: { authRequired: true },
  //   props: (route) => ({ user: store.state.auth.currentUser || {} }),
  // },
  // {
  //   path: '/order/bill',
  //   component: () =>
  //     lazyLoadView(import('@/src/router/views/pages/order/bill')),
  //   meta: { authRequired: true },
  //   props: (route) => ({ user: store.state.auth.currentUser || {} }),
  // },
]

const orderListRoutes = [
  {
    path: "/order",
    name: "Order List",
    icon: "grid",
    component: () => lazyLoadView(import("@/src/router/views/pages/order/saleOrder/index")),
    meta: { authRequired: true },
    props: route => ({ user: store.state.auth.currentUser || {} })
  },
  {
    path: '/order/:orderId',
    component: () =>
      lazyLoadView(import('@/src/router/views/pages/order/saleOrder/detail')),
    meta: { authRequired: true },
    props: route => ({ user: store.state.auth.currentUser || {} })
  },
];

const logRoutes = [
  {
    path: "/logs",
    name: "Logs",
    icon: "grid",
    component: () => lazyLoadView(import("@/src/router/views/pages/logs/index")),
    meta: { authRequired: true },
    props: route => ({ user: store.state.auth.currentUser || {} })
  },
]


let authProtectedRoutes = []
const findRouteByPath = path => authProtectedRoutes.find(route => route.path === path)

if(store.state.auth.currentUser && store.state.auth.currentUser.data.user.role === 'admin')
{
  // authProtectedRoutes = [
  //   ...homeRoutes,
  //   ...cartRoutes,
  //   ...orderRoutes,    
  // ];
  authProtectedRoutes = [
    ...dashboardRoutes,
    ...homeRoutes,
    ...cartRoutes,
    ...orderRoutes,    
    ...reportRoutes,
  ];
   //DashBoard
   findRouteByPath("/dashboard").children = findRouteByPath("/dashboard").children.filter(function (obj)
   { return  obj.path != "saler"   && obj.path != "delivery"  }  )
  //report
  authProtectedRoutes.find(e => e.name == "Report").children = authProtectedRoutes.find(e => e.name == "Report").children.filter(function (obj)  
  { return  obj.path != 'logdetail' && obj.path != 'deliveryreport'   && obj.path != 'invoicereport' }  );
}
else if(store.state.auth.currentUser && store.state.auth.currentUser.data.user.role === 'adminAccount')
{
  // authProtectedRoutes = [
  //   ...homeRoutes,
  //   ...orderRoutes,
  //   ...manageMemberAdminACCRoutes,
  // ];
  authProtectedRoutes = [
    ...dashboardRoutes,
    ...homeRoutes,
    ...orderRoutes,
    ...manageMemberAdminACCRoutes,
    ...reportRoutes,
  ];
   //DashBoard
   findRouteByPath("/dashboard").children = findRouteByPath("/dashboard").children.filter(function (obj)
   { return  obj.path == "account"    }  )
  //report
  authProtectedRoutes.find(e => e.name == "Report").children = authProtectedRoutes.find(e => e.name == "Report").children.filter(function (obj)
    { return  obj.path != 'systemoverview' && obj.path != 'orderreport'  && obj.path != 'backorderreport'  && obj.path != 'deliveryreport' && obj.path != 'logdetail'  }  )
}
else if(store.state.auth.currentUser && store.state.auth.currentUser.data.user.role === 'adminMarketing')
{
  // authProtectedRoutes = [
  //   ...homeRoutes,
  //   ...orderRoutes,
  //   ...memberApproveRoutes,
  // ];
  authProtectedRoutes = [
    ...dashboardRoutes,
    ...homeRoutes,
    ...orderRoutes,
    ...memberApproveRoutes,
    ...reportRoutes,
  ];
  //DashBoard
  findRouteByPath("/dashboard").children = findRouteByPath("/dashboard").children.filter(function (obj)
    { return  obj.path == "saler"    }  );
  //report
  authProtectedRoutes.find(e => e.name == "Report").children = authProtectedRoutes.find(e => e.name == "Report").children.filter(function (obj)
    { return  obj.path != 'systemoverview'   && obj.path != 'invoicereport'  && obj.path != 'deliveryreport' && obj.path != 'logdetail'  }  );
}
else if(store.state.auth.currentUser && store.state.auth.currentUser.data.user.role === 'adminDeliveryMan')
{
  // authProtectedRoutes = [
  //   ...homeRoutes,
  //   ...waitingDeliveryNoteRoutes,
  //   ...deliveryOrderListRoutes,
  // ];
  authProtectedRoutes = [
    ...dashboardRoutes,
    ...homeRoutes,
    ...waitingDeliveryNoteRoutes,
  //  ...orderListRoutes,
    ...deliveryOrderListRoutes,
    ...reportRoutes,
  ];
  //DashBoard
  findRouteByPath("/dashboard").children = findRouteByPath("/dashboard").children.filter(function (obj)
    { return  obj.path =="delivery"  }  );
  //report
   authProtectedRoutes.find(e => e.name == "Report").children = authProtectedRoutes.find(e => e.name == "Report").children.filter(function (obj) 
 { return   obj.path == 'deliveryreport'  }  )
}
else if(store.state.auth.currentUser && store.state.auth.currentUser.data.user.role === 'deliveryMan')
{
  authProtectedRoutes = [
    ...homeRoutes,
    ...deliveryListRoutes,
  ];
}
else if(store.state.auth.currentUser && store.state.auth.currentUser.data.user.role === 'saleman')
{
 // authProtectedRoutes = [
  //   ...homeRoutes,
  //   ...cartRoutes,
  //   ...orderListRoutes,
  // ];
  authProtectedRoutes = [
    ...dashboardRoutes,
    ...homeRoutes,
    ...cartRoutes,
   // ...orderListRoutes,
   ...orderRoutes,
    ...reportRoutes,
  ];
  //DashBoard
  findRouteByPath("/dashboard").children = findRouteByPath("/dashboard").children.filter(function (obj)
    { return  obj.path == "saler"    }  );
    //report
     authProtectedRoutes.find(e => e.name == "Report").children = authProtectedRoutes.find(e => e.name == "Report").children.filter(function (obj) 
 { return  obj.path != 'logdetail' && obj.path != 'deliveryreport'   && obj.path != 'amountreport'  && obj.path != 'memberreport'  
 && obj.path != 'systemoverview' }  )
}
else if (store.state.auth.currentUser && (store.state.auth.currentUser.data.user.username === 'adminContent' || store.state.auth.currentUser.data.user.username === 'superAdmin'))
{
 
  authProtectedRoutes = [
    ...homeRoutes,
    ...dashboardRoutes,
    ...cartRoutes,
    ...orderRoutes,
    ...productRoutes,
    ...userRoutes,
    ...manageMemberRoutes,
    ...manageDeliveryRoutes,
    ...reportRoutes,
    ...contentRoutes
  ];
   //วิธีตัดหน้าไม่จำเป็นสำหรับ authen
 // authProtectedRoutes.find(e => e.name == "Report").children = authProtectedRoutes.find(e => e.name == "Report").children.filter(function (obj) 
 // { return  obj.path != 'logdetail' && obj.path != 'deliveryreport'  }  )
}
else
{
 
  authProtectedRoutes = [
    ...homeRoutes,
    ...dashboardRoutes,
    ...cartRoutes,
    ...orderRoutes,
    ...productRoutes,
    ...userRoutes,
    ...manageMemberRoutes,
    ...manageDeliveryRoutes,
    ...reportRoutes,
  ];
   //วิธีตัดหน้าไม่จำเป็นสำหรับ authen
 // authProtectedRoutes.find(e => e.name == "Report").children = authProtectedRoutes.find(e => e.name == "Report").children.filter(function (obj) 
 // { return  obj.path != 'logdetail' && obj.path != 'deliveryreport'  }  )
}
const allRoutes = [...authRoutes, ...authProtectedRoutes, ...errorPagesRoutes, ...logRoutes];

export { allRoutes, authProtectedRoutes };

// Lazy-loads view components, but with better UX. A loading view
// will be used if the component takes a while to load, falling
// back to a timeout view in case the page fails to load. You can
// use this component to lazy-load a route with:
//
// component: () => lazyLoadView(import('@views/my-view'))
//
// NOTE: Components loaded with this strategy DO NOT have access
// to in-component guards, such as beforeRouteEnter,
// beforeRouteUpdate, and beforeRouteLeave. You must either use
// route-level guards instead or lazy-load the component directly:
//
// component: () => import('@views/my-view')
//
function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    // A component to use while the component is loading.
    loading: require("@components/_loading").default,
    // Delay before showing the loading component.
    // Default: 200 (milliseconds).
    delay: 400,
    // A fallback component in case the timeout is exceeded
    // when loading the component.
    // error: require('@views/_timeout').default,
    // Time before giving up trying to load the component.
    // Default: Infinity (milliseconds).
    timeout: 10000
  });

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children);
    }
  });
}
